import React from "react";
import { Auth } from "aws-amplify";
import { Redirect, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";

export default function SignOutComponent() {
  const dispatch = useDispatch();
  const location = useLocation();

  Auth.signOut().then(() => {
    localStorage.clear();
    dispatch({ type: "USER_LOGOUT" });
    sessionStorage.clear();
  });

  return (
    <Redirect
      to={{
        pathname: "/login",
        state: location.state,
      }}
    />
  );
}
